import { UrlUtils } from "@sazka/utils/url";

export const useDsModalVideoTools = (urlOrCode: string) => {
    const embedVideoUrl = (() => {
        // is embed url
        if (urlOrCode.indexOf("embed") >= 0) return urlOrCode;

        // get code from youtube url
        const code = UrlUtils.getQueryString("v", urlOrCode);
        return `https://www.youtube-nocookie.com/embed/${code || urlOrCode}?autoplay=1`;
    })();

    return {
        embedVideoUrl,
    };
};
